// Practice billing-profile helpers.
//
// Rate SELECTION happens server-side (POST /tariff-rates/resolve, see
// backend/src/services/tariffResolverService.js); the frontend only needs to
// display a practice's effective contract flags, e.g. in the practice
// profile forms.

/**
 * The practice's contract profile as a lowercase string array, e.g.
 * ["jsp","nnw"]. Reads the structured tariffProfile when present and falls
 * back to the legacy practiceContract field (string or array) so
 * half-migrated practices display identically.
 */
export function contractsFromPractice(practice) {
  const tp = practice?.tariffProfile;
  if (tp && typeof tp === "object") {
    const contracts = [];
    if (tp.jspMember) contracts.push("jsp");
    if (tp.nonContractedUsesNNW) contracts.push("nnw");
    return contracts;
  }
  const legacy = practice?.practiceContract;
  const list = Array.isArray(legacy) ? legacy : legacy ? [legacy] : [];
  return list.map((c) => String(c).toLowerCase().trim()).filter(Boolean);
}
